import {TypeOf} from 'io-ts';
import {BaseCurrencyCode} from './BaseCurrencyCode';

export const TokenCurrencyCode = BaseCurrencyCode;
export type TokenCurrencyCode = TypeOf<typeof TokenCurrencyCode>;
